export default __webpack_public_path__ + "static/media/Group138.7094b8ca.png";